export default "__VITE_ASSET__yClFewvo__"